function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { jsx as _jsx } from "react/jsx-runtime";
function AspectBanner(_ref) {
  var image = _ref.image,
    isMobile = _ref.isMobile,
    containerClassName = _ref.containerClassName,
    onClick = _ref.onClick;
  var _useState = useState(0.262),
    _useState2 = _slicedToArray(_useState, 2),
    aspectRatio = _useState2[0],
    setAspectRatio = _useState2[1]; // default ratio (283 / 1080)
  var history = useHistory();
  var handleImageLoad = function handleImageLoad(e) {
    var _e$target = e.target,
      naturalWidth = _e$target.naturalWidth,
      naturalHeight = _e$target.naturalHeight;
    setAspectRatio(naturalHeight / naturalWidth);
  };
  var onClickHandler = function onClickHandler() {
    switch (onClick) {
      case "DEALS":
        history.push("/deals/2995");
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(containerClassName ? containerClassName : "w-full", " ").concat(isMobile ? "lg:hidden" : "hidden lg:block"),
    children: /*#__PURE__*/_jsx("div", {
      style: {
        width: "100%",
        paddingBottom: "".concat(aspectRatio * 100, "%"),
        position: "relative"
      },
      onClick: onClickHandler,
      className: " ",
      children: /*#__PURE__*/_jsx("picture", {
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%"
        },
        children: /*#__PURE__*/_jsx("img", {
          src: image,
          alt: "Banner",
          onLoad: handleImageLoad,
          style: {
            width: "100%",
            height: "100%",
            objectFit: "cover"
          }
        })
      })
    })
  });
}
export default AspectBanner;
export var lambda = "KmV4";